import { GET_API, POST_API, PUT_API, DELETE_API, PATCH_API } from "./APIs";
import { clearInsightsCache } from "./insightsCache";
import {
  clearRestaurantCache,
  fetchWithRestaurantDropdownCache,
  isDropdownQuery,
} from "./restaurantCache";
import {
  getNext2amISTDate,
  isSessionExpired,
  expireSession,
  SESSION_EXPIRY_KEY,
} from "./sessionManager";

import {
  itemsDetailsUrl,
  orderDeliveryBoyUrl,
  orderDetailsUrl,
  branchDetailsUrl,
  branchAdminAddUrl,
  userUserCategoryUrl,
  accountsUrl,
  deliveryDbDetailsUrl,
  userProfileUrl,
  orderStatusUrl,
  reviewReviewUrl,
  itemsVarientUrl,
  promocodesDetailsUrl,
  itemsCategoryUrl,
  itemsOfferUrl,
  notificationsAdminTokenUrl,
} from "../Constants/apiUrls";

// import Cookies from"js-cookies"
import cookies from "js-cookie";
import { appendSale } from "../Pages/Products/sale";
import { store } from "./notifications";
import {
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
} from "./Config";
import { forgetPickedFranchise } from "./pickedFranchise";

// Returns the next occurrence of 3:00 AM IST as an ISO string.
// If it's already past 3 AM IST today, targets 3 AM tomorrow.
export const getNext3amIST = () => {
  const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000; // UTC+5:30
  const nowUTC = Date.now();
  const nowIST = new Date(nowUTC + IST_OFFSET_MS);

  const next3am = new Date(nowIST);
  next3am.setHours(3, 0, 0, 0);

  if (nowIST >= next3am) {
    next3am.setDate(next3am.getDate() + 1);
  }

  // Convert back to UTC for storage
  return new Date(next3am.getTime() - IST_OFFSET_MS).toISOString();
};

export const showMessage = (message, type, title, insert, container) => {
  store.addNotification({
    title: title,
    message: message,
    type: type, //success, default, warning, info, danger
    insert: insert, //top,bottom
    container: container, //top-left, top-right, top-center, bottom-left, bottom-right, bottom-center
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: type === "danger" ? 5000 : 2000,
    },
  });
};

export const getLocalStorageData = () => {
  let data = localStorage.getItem("foodoor_token");
  if (data) {
    data = JSON.parse(localStorage.getItem("foodoor_token"));
    return data;
  } else {
    return null;
  }
};

export const setDataOnLocalstorage = (data) => {
  if (!data) {
    return 0;
  }
  localStorage.setItem("foodoor_token", JSON.stringify(data));
};

export const setDataOnCookie = (data) => {
  if (!data) {
    return 0;
  }
  const next2am = getNext2amISTDate();
  localStorage.setItem(SESSION_EXPIRY_KEY, String(next2am.getTime()));
  cookies.set("foodoor_token", JSON.stringify(data), {
    expires: next2am,
    sameSite: "Lax",
  });
};

export const getToken = () => {
  if (isSessionExpired()) {
    expireSession();
    return "no_token";
  }
  if (cookies.getJSON("foodoor_token")) {
    return cookies.getJSON("foodoor_token").token;
  } else {
    return "no_token";
  }
};

export const unsetDataOnLocalstorage = () => {
  localStorage.removeItem("foodoor_token");
  localStorage.removeItem(SESSION_EXPIRY_KEY);
  clearInsightsCache();
  clearRestaurantCache();
};

export const unsetDataOnCookie = () => {
  cookies.remove("foodoor_token");
};

export const Logout = () => {
  forgetPickedFranchise();
  unsetDataOnLocalstorage();
  unsetDataOnCookie();
};

export const LoginAPI = async (data) => {
  let username = data.email;
  let password = data.password;
  var fdata = new FormData();
  fdata.append("username", username);
  fdata.append("password", password);

  let result = POST_API(fdata, {});
  return await result.then(function (result) {
    let value = -1;
    if (result) {
      if (result.data.Status === true) {
        let token = result.data;
        setDataOnLocalstorage(token);
        setDataOnCookie(token);
        value = token;
      }
    } else {
      value = 0;
    }
    return value;
  });
};

export const ResponseValidation = (response) => {
  let response_data = null;
  let message = null;

  if (response) {
    if (response.status) {
      if (response.status === 200) {
        message = "Success";
        response_data = response;
        //showMessage(JSON.stringify(response.data),"success","Success!","top","top-right", 0)
      } else if (response.status === 401) {
        unsetDataOnCookie();
        // history.push("/login");

        showMessage(
          JSON.stringify(response.data),
          "danger",
          "Unauthorized!",
          "top",
          "top-right",
          0,
        );
        window.location.replace("/login");
        message = "Unauthorised user, you dont have permission to access this";
        response_data = 0;
      } else if (response.status === 404) {
        message = "Page Not found";
        response_data = 0;
        // showMessage(JSON.stringify(response.data),"danger","Not found!","top","top-right",0);
      } else if (response.status === 500) {
        message = "Internal Server Error";
        response_data = 0;
        showMessage(
          JSON.stringify(response.data),
          "danger",
          "Server error!",
          "top",
          "top-right",
          0,
        );
      } else if (response.status === 503) {
        message = "Seems like server is not running";
        response_data = 0;

        showMessage(
          message,
          "danger",
          "Server not running!",
          "top",
          "top-right",
          0,
        );
      } else {
        message = "Unhandled Condition met";
        response_data = 0;
        const response_message = JSON.stringify(response.data);
        if (
          response_message.match("Unable to log in with provided credentials.")
        ) {
          showMessage(
            "invalid username or email ",
            "danger",
            "Unhandled!",
            "top",
            "top-right",
            0,
          );
        } else if (
          response_message.match("delivery boy's accounts not cleared")
        ) {
          showMessage(
            response.data.Error,
            "danger",
            "Cannot Delete",
            "top",
            "top-right",
            0,
          );
        }
      }

      return response_data;
    } else {
      message = "unexpected response got";

      showMessage(
        JSON.stringify(response.data),
        "danger",
        "Unexpected response!",
        "top",
        "top-right",
        0,
      );
      return 0;
    }
  }
  // else if(response.data)
  else {
    return 0;
  }
};

export const appendImages = (fdata, images) => {
  if (!images) return;
  // The crop picker hands back one File (onChange(finalFile)); other screens
  // hold an array. A File has no .length, so a for loop over it appends nothing.
  const list = Array.isArray(images) || images instanceof FileList ? images : [images];
  for (const image of list) {
    if (image) fdata.append("images", image);
  }
};

export const ManageProducts = async (e, data, keyword, params, sloatID) => {
  let path = itemsDetailsUrl;
  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "add") {
    var fdata = new FormData();

    fdata.append("name", data.name);

    if (data.product_commission != "") {
      fdata.append("product_commission", data.product_commission);
    }

    // fdata.append("category", data.category);
    fdata.append("description", data.description);

    appendImages(fdata, data.images);
    fdata.append("varients", JSON.stringify(data.variants));
    //fdata.append("item_type", data.type); // 'non-vegetarian' 'vegetarian' 'eggetarian'

    fdata.append("branch_id", data.branch);
    fdata.append("category_tag", JSON.stringify(data.category_tag));
    fdata.append("inner_category", JSON.stringify(data.inner_category));
    // fdata.append("service_charge", data.service_charge ? data.service_charge :"0");
    fdata.append("service_charge", "0");
    fdata.append("subcategory", "");

    fdata.append("is_new", data.is_new);
    fdata.append("is_popular", data.is_popular);
    fdata.append("is_recommended", data.is_recommended);
    fdata.append("is_bundle", data.is_bundle);
    fdata.append("is_trending", data.is_trending);
    fdata.append("occasion_tag", data.occasion_tag);
    appendSale(fdata, data);
    // if (data.inner_category1 =="") {
    //   fdata.append("inner_category","");
    // } else {
    //   fdata.append("inner_category", data.inner_category);
    // }

    // fdata.append("slots","[]");
    fdata.append("brand", "");
    fdata.append("is_subscribable", "false");
    fdata.append("is_service", "1");

    // fdata.append("is_out_of_stock", true)
    let sloatArray = [];
    for (var i = 0; i < data.sloats.length; i++) {
      sloatArray.push(data.sloats[i].id);
    }

    fdata.append("slots", JSON.stringify(sloatArray));

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "update") {
    var fdata = new FormData();

    fdata.append("id", data.id);
    fdata.append("name", data.name);
    // if (data.product_commission) {
    //   fdata.append("product_commission", data.product_commission);
    // }
    data.product_commission !== null &&
      fdata.append("product_commission", data.product_commission);

    // fdata.append("category", data.category);
    const catTagIds = (data.category_tag || []).map(tag => tag && typeof tag === 'object' ? tag.id : tag);
    fdata.append("category_tag", JSON.stringify(catTagIds));
    if (data.inner_category1 != "") {
      fdata.append("inner_category", data.inner_category1);
    } else {
      fdata.append("inner_category", "");
    }

    fdata.append("description", data.description);
    fdata.append("branch_id", data.branch.id); //shabeeb change

    fdata.append("subcategory", "");
    fdata.append("slots", "[]");
    fdata.append("brand", "");
    fdata.append("is_subscribable", "false");
    fdata.append("service_charge", "0");
    // fdata.append("service_charge", data.service_charge ? data.service_charge :"0");
    fdata.append("is_service", "0");
    fdata.append("is_blocked", "0");
    fdata.append("is_out_of_stock", data.is_out_of_stock);

    fdata.append("is_new", data.is_new);
    fdata.append("is_popular", data.is_popular);
    fdata.append("is_recommended", data.is_recommended);
    fdata.append("is_bundle", data.is_bundle);
    fdata.append("is_trending", data.is_trending);
    fdata.append("occasion_tag", data.occasion_tag);
    appendSale(fdata, data);
    appendImages(fdata, data.images);

    let result = PUT_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "patch") {
    // var FormData = require('form-data');
    var fdata = new FormData();
    const patchKeyword = data.keyword || "out_of_stock";
    fdata.append("keyword", patchKeyword);
    fdata.append("item_id", data.item_id);
    if (patchKeyword === "sale") {
      fdata.append("on_sale", data.on_sale ? "true" : "false");
      if (data.on_sale) fdata.append("sale_discount", data.sale_discount);
    } else if (patchKeyword === "temporarily_unavailable") {
      fdata.append("temporarily_unavailable", data.temporarily_unavailable);
    } else {
      fdata.append("out_of_stock", data.out_of_stock);
    }
    let result = PATCH_API(fdata, "", path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    let result = DELETE_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "remove_sloat") {
    var fdata = new FormData();
    fdata.append("item_id", data.id);
    fdata.append("keyword", "remove_sloat");
    fdata.append("sloats", JSON.stringify([sloatID]));

    let result = PATCH_API(fdata, params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword === "add_sloat") {
    var fdata = new FormData();
    fdata.append("item_id", data.id);

    fdata.append("keyword", "add_sloat");

    let sloatArray = [];
    for (var i = 0; i < data.sloats.length; i++) {
      sloatArray.push(data.sloats[i].id);
    }

    fdata.append("sloats", JSON.stringify(sloatArray));

    let result = PATCH_API(fdata, params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "") {
  }
};

export const ManageGetAssignedDeliveryBoys = async (
  e,
  keyword,
  data,
  params,
) => {
  let path = orderDeliveryBoyUrl;

  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageOrders = async (e, keyword, data, params) => {
  let path = orderDetailsUrl;

  if (keyword == "add") {
    var fdata = new FormData();

    fdata.append("name", data.name);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "update") {
    var fdata = new FormData();
    fdata.append("id", data.id);
    fdata.append("name", data.name);

    let result = PUT_API(fdata, "", path);

    // return 0
    return await result.then((result) => {
      if (result) {
        return result.status;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    let result = DELETE_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "patch") {
    let fdata = new FormData();

    if (data.keyword == "assign_deliveryboy") {
      fdata.append("deliveryboy_id", data.deliveryboy_id);
      fdata.append("keyword", data.keyword);
      fdata.append("order_id", data.order_id);
    }

    if (data.keyword == "change_status") {
      fdata.append("keyword", data.keyword);
      fdata.append("order_id", data.orderid);
      fdata.append("status_id", data.id);
      fdata.append("description", data.desc);
      fdata.append("cancelation_type", data.cancelation_type);
    }

    if (data.keyword == "cancel_order") {
      fdata.append("keyword", data.keyword);
      fdata.append("order_id", data.orderid);
      fdata.append("status_id", data.id);
      fdata.append("description", data.desc);
      fdata.append("cancelation_type", data.cancelation_type);
    }

    let result = PATCH_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageRestaurant = async (e, data, keyword, params) => {
  let path = branchDetailsUrl;

  if (keyword == "add") {
    path = branchAdminAddUrl;
    // path = "/branch/add-restaurant/";
    var fdata = new FormData();

    fdata.append("branch_name", data.branch_name);
    fdata.append("place", data.place);
    fdata.append("radius", data.radius);
    fdata.append(
      "available_radius",
      data.available_radius ? data.available_radius : 0.0,
    );
    fdata.append("self_pickup", data.self_pickup ? "True" : "False");
    if (
      data.self_pickup_restaurent_charge !== "" &&
      data.self_pickup_restaurent_charge != null
    ) {
      fdata.append(
        "self_pickup_restaurent_charge",
        data.self_pickup_restaurent_charge,
      );
    }
    fdata.append("pure_veg", data.pure_veg ? "True" : "False");
    fdata.append("is_celebration_store", data.is_celebration_store ? "true" : "false");
    fdata.append("is_cake_store", data.is_cake_store ? "true" : "false");
    fdata.append("free_delivery", data.free_delivery ? "true" : "false");
    fdata.append("latitude", data.latitude);
    fdata.append("longitude", data.longitude);
    fdata.append("address", data.address);
    fdata.append("mobile", data.mobile);
    if (data.email && data.email != "null") {
      fdata.append("email", data.email);
    }
    fdata.append("fssai_code", data.fssai);
    fdata.append("commission", data.commission);
    fdata.append("description", data.description);
    fdata.append("expence_meter", data.expence_meter);
    fdata.append("time_to_cook", data.time_to_cook);

    appendImages(fdata, data.images);

    fdata.append("admin_name", data.admin[0].admin_name);
    fdata.append("admin_username", data.admin[0].admin_username);
    fdata.append("admin_password", data.admin[0].admin_password);
    fdata.append("admin_mobile", data.admin[0].admin_mobile || "");
    fdata.append("admin_email", data.admin[0].admin_email);

    fdata.append("managers_list", JSON.stringify(data.managers));

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        clearRestaurantCache();
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "update") {
    path = branchAdminAddUrl;
    var fdata = new FormData();
    fdata.append("branch_name", data.branch_name);
    fdata.append("branch_id", data.id);
    fdata.append("place", data.place);
    fdata.append("latitude", data.latitude);
    fdata.append("longitude", data.longitude);
    fdata.append("address", data.address);

    fdata.append("mobile", data.mobile);
    if (data.email && data.email != "null") {
      fdata.append("email", data.email);
    }
    fdata.append("fssai_code", data.fssai);
    fdata.append("description", data.description);
    fdata.append("expence_meter", data.expence_meter);
    fdata.append("time_to_cook", data.time_to_cook);
    fdata.append("base_delivery_charge", data.base_delivery_charge);
    fdata.append("radius", data.radius);
    fdata.append(
      "available_radius",
      data.available_radius ? data.available_radius : 0.0,
    );
    fdata.append("self_pickup", data.self_pickup ? "True" : "False");
    if (
      data.self_pickup_restaurent_charge !== "" &&
      data.self_pickup_restaurent_charge != null
    ) {
      fdata.append(
        "self_pickup_restaurent_charge",
        data.self_pickup_restaurent_charge,
      );
    }
    fdata.append("pure_veg", data.pure_veg ? "True" : "False");
    fdata.append("is_celebration_store", data.is_celebration_store ? "true" : "false");
    fdata.append("is_cake_store", data.is_cake_store ? "true" : "false");
    fdata.append("free_delivery", data.free_delivery ? "true" : "false");

    appendImages(fdata, data.images);
    appendImages(fdata, data.latestImage);

    data.adminEdit && fdata.append("keyword", "admin_update");
    fdata.append("admin_name", data.admin_name);
    fdata.append("admin_username", data.admin_username);
    fdata.append("admin_password", data.admin_password);
    fdata.append("admin_mobile", data.admin_mobile || "");
    let result = PUT_API(fdata, "", path, "");
    return await result.then((result) => {
      if (result) {
        clearRestaurantCache();
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "patch") {
    let path = branchDetailsUrl;
    var fdata = new FormData();

    fdata.append("branch_id", data.branch_id);
    fdata.append("keyword", "commission");
    fdata.append("commission", data.commission);
    let result = PATCH_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        clearRestaurantCache();
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "delete") {
    let result = DELETE_API("", params, path);

    return await result.then((result) => {
      if (result) {
        clearRestaurantCache();
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "get") {
    let result = isDropdownQuery(params)
      ? fetchWithRestaurantDropdownCache(params, () => GET_API("", params, path))
      : GET_API("", params, path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageUsers = async (e, data, keyword, params) => {
  let path = userUserCategoryUrl;
  if (keyword == "get") {
    let result = GET_API("", params, path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const AccountTransactions = async (e, data, keyword) => {
  if (e) {
    e.preventDefault();

    let path = accountsUrl;

    if (keyword == "add") {
      var fdata = new FormData();
      fdata.append("del_id", data.id);
      if (data.keyword == "delivery_balance") {
        fdata.append("amount", data.delivery_charge_balance);
        fdata.append("discription", data.get_desc);
      } else {
        fdata.append("amount", data.balance);
        fdata.append("discription", data.pay_desc);
      }
      fdata.append("keyword", data.keyword);
      let result = POST_API(fdata, "", path);

      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    }
  }
};

export const ManageDeliveryBoy = async (e, keyword, data, params) => {
  let path = deliveryDbDetailsUrl;

  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "update") {
    // return 0
    var fdata = new FormData();
    fdata.append("name", data.first_name);
    fdata.append("email", data.email);
    fdata.append("username", data.username);
    fdata.append("user_id", data.user_id);
    fdata.append("is_approved", data.is_approved);
    fdata.append("is_blocked", data.is_blocked);

    if (data.password) {
      fdata.append("password", data.password);
    }

    fdata.append("mobile", data.mobile);
    fdata.append("address1", data.address1);
    fdata.append("address2", data.address2);
    fdata.append("land_mark", data.land_mark);
    // This screen does not edit the address, but /user/profile/ requires these
    // keys. Blank means "leave unchanged" -- sending real-looking values here
    // would overwrite the rider's own address.
    fdata.append("latitude", "");
    fdata.append("longitude", "");
    fdata.append("city", "");
    fdata.append("pin", "");
    fdata.append("state", "");
    // fdata.append("delivery_limit");

    let result = PUT_API(fdata, "", "/user/profile/");

    // return 0
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "") {
  }
};
export const GetDeliveryBoys = async (e, keyword, data, params) => {
  // let path ="/user/delboys/"
  let path = deliveryDbDetailsUrl;

  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "patch") {
    var fdata = new FormData();

    fdata.append("keyword", "block_del_boy");

    fdata.append("del_id", data.id);
    fdata.append("is_blocked", data.is_blocked1);

    let result = PATCH_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageDeliveryBoys = async (e, keyword, data, params) => {
  let path = userProfileUrl;

  if (keyword == "add") {
    var fdata = new FormData();

    fdata.append("keyword", data.keyword);
    fdata.append("username", data.username);
    fdata.append("name", data.name);
    fdata.append("email", data.email);
    fdata.append("password", data.password);
    fdata.append("mobile", data.mobile);
    fdata.append("address1", data.address1);
    fdata.append("address2", "your address");
    fdata.append("land_mark", "your nearest location");
    fdata.append("latitude", 10.976);
    fdata.append("longitude", 76.2254);
    fdata.append("city", "Perinthalmanna");
    fdata.append("pin", "679322");
    fdata.append("state", "kerala");

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "update") {
    return 0;
  }
  if (keyword == "delete") {
    // let path = "/user/delboys/";
    let path = deliveryDbDetailsUrl;

    let result = DELETE_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get_in_order") {
    let path = deliveryDbDetailsUrl;
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ORDER_STATUS_LIST = [
  { id: 1, name: "pending" },
  { id: 2, name: "approved" },
  { id: 3, name: "declined" },
  { id: 4, name: "delivery boy assigned" },
  { id: 5, name: "out for delivery" },
  { id: 6, name: "delivered" },
  { id: 7, name: "cancelled" },
  { id: 8, name: "transfer" },
  { id: 9, name: "" },
];

export const ManageStatus = async (e, keyword, data, params) => {
  let path = orderStatusUrl;
  params = "";

  if (keyword == "add") {
    var fdata = new FormData();

    fdata.append("name", data.name);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result.status;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "patch") {
    var fdata = new FormData();

    fdata.append("name", data.name);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result.status;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "update") {
    var fdata = new FormData();
    fdata.append("id", data.id);
    fdata.append("name", data.name);

    let result = PUT_API(fdata, "", path);

    // return 0
    return await result.then((result) => {
      if (result) {
        return result.status;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    let result = DELETE_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get") {
    return Promise.resolve({
      status: 200,
      data: ORDER_STATUS_LIST,
    });
  }
};

export const ManageComments = async (e, data, keyword, params) => {
  // e.preventDefault()
  if (keyword == "get") {
    let path = reviewReviewUrl;
    // let params = 'keyword=items&my_review=true'
    let result = GET_API("", params, path);
    return await result.then((result) => {
      //          let value=-1
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageVariants = async (e, keyword, data, params) => {
  let path = itemsVarientUrl;

  if (keyword == "add") {
    var fdata = new FormData();

    fdata.append("name", data.name);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "update") {
    var fdata = new FormData();
    fdata.append("id", data.id);
    fdata.append("name", data.name);

    let result = PUT_API(fdata, "", path);

    // return 0
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    let result = DELETE_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManagePromocode = async (e, data, keyword, params) => {
  let Data = data.data;
  if (e) {
    e.preventDefault();
  }

  let path = promocodesDetailsUrl;

  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "update") {
    var fdata = new FormData();
    fdata.append("id", data.id);
    fdata.append("is_active", data.is_active);
    fdata.append("description", data.description);
    fdata.append("ex_date", data.expiry_date && data.expiry_date + " 00:00:00");

    fdata.append(
      "applicable_branches",
      data.applicable_branches.length > 0
        ? JSON.stringify(data.applicable_branches)
        : "[]",
    );
    fdata.append("allowed_users", JSON.stringify(data.allowed_users));

    fdata.append("recurrence", data.recurrence);
    if (data.disc_perc != "") {
      fdata.append("disc_perc", data.disc_perc);
    } else {
      fdata.append("flat_disc", data.flat_disc);
    }
    if (data.uplimit) {
      fdata.append("uplimit", data.uplimit);
    }
    fdata.append(
      "from_date",
      data.from_date ? data.from_date + " 00:00:00" : "",
    );
    fdata.append("min_amount", data.min_amount);
    fdata.append("is_for_new_user", data.is_for_new_user ? "true" : "false");
    fdata.append("self_pickup_only", data.self_pickup_only ? "true" : "false");
    let result = PUT_API(fdata, "", path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "add") {
    var fdata = new FormData();
    fdata.append("promo_code", Data.code);
    fdata.append("description", Data.description);
    fdata.append("ex_date", Data.expiry_date && Data.expiry_date + " 00:00:00");
    fdata.append("allowed_users", JSON.stringify(Data.allowed_users));
    fdata.append("recurrence", Data.recurrence);
    if (Data.disc_perc) {
      fdata.append("disc_perc", Data.disc_perc);
      fdata.append("uplimit", Data.uplimit);
    } else {
      fdata.append("flat_disc", Data.flat_disc);
      fdata.append("uplimit", 0);
    }
    fdata.append(
      "applicable_branches",
      data.branch ? `[${data.branch}]` : "[]",
    );
    fdata.append("from_date", Data.from_date && Data.from_date + " 00:00:00");
    fdata.append("min_amount", Data.min_amount);
    fdata.append("is_for_new_user", Data.is_for_new_user ? "true" : "false");
    fdata.append("self_pickup_only", Data.self_pickup_only ? "true" : "false");
    let result = POST_API(fdata, "", path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "delete") {
    let result = DELETE_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageCustomer = async (e, data, keyword, params) => {
  if (e) {
    e.preventDefault();
  }
  let path = userProfileUrl + "?keyword=all_profile";
  if (keyword == "add") {
    if (data.keyword == "admin") {
      path = userProfileUrl;
      let result = GET_API("", params, path);
      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    }
  }

  if (keyword == "get") {
    if (params != "") {
      path = userProfileUrl;
      let result = GET_API("", params, path);
      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    } else {
      let result = GET_API("", params, path);
      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    }
  }
};

export const ManageCategory = async (e, data, keyword, params) => {
  // e.preventDefault()
  const path = itemsCategoryUrl;

  if (keyword == "add") {
    var fdata = new FormData();
    fdata.append("name", data.name);
    // fdata.append("bg_image", data.bg_image);
    fdata.append("icon", data.icon);
    fdata.append("is_active", data.is_active);
    fdata.append("is_blocked", data.is_blocked);
    fdata.append("inner_category", data.inner_category);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "update") {
    var fdata = new FormData();
    fdata.append("id", data.id);
    fdata.append("name", data.name);
    fdata.append("bg_image", data.bg_image);
    fdata.append("icon", data.icon);
    fdata.append("is_active", data.is_active);
    fdata.append("is_blocked", data.is_blocked);
    fdata.append("inner_category", data.inner_category);

    let result = PUT_API(fdata, "", path);

    // return 0
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    let result = DELETE_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "get") {
    let result = GET_API("", params, path);

    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageOffers = async (e, data, keyword, params) => {
  let path = itemsOfferUrl;

  if (keyword == "get") {
    let result = GET_API("", params, path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "add") {
    if (data.type == "item") {
      // let path ="/items/itemdiscount/";

      var fdata = new FormData();
      fdata.append("item_id", data.item_id);
      fdata.append("disc_perc", data.disc_perc);
      fdata.append("flat_disc", data.flat_disc);
      fdata.append("heading", data.heading);
      fdata.append("offer_type", data.type);
      fdata.append("heading_priority", data.heading_priority);
      fdata.append("is_hero_offer", data.is_banner);
      fdata.append("latitude", data.latitude);
      fdata.append("longitude", data.longitude);

      if (data.is_banner === true) {
        if (data.banner_image) fdata.append("image", data.banner_image);
      } else {
        if (data.image) fdata.append("image", data.image);
        if (data.second_image) fdata.append("second_image", data.second_image);
      }

      fdata.append(
        "expiry_date",
        data.expiry_date && data.expiry_date + " 00:00:00",
      );

      let result = POST_API(fdata, "", path);
      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    } else {
      var fdata = new FormData();
      fdata.append("disc_perc", data.disc_perc);
      (is_franchise_admin || is_franchise_manager || is_franchise_staff) &&
        fdata.append("branch_id", data.branch_id);
      fdata.append("flat_discount", data.flat_disc);
      fdata.append("heading", data.heading);
      fdata.append("offer_type", data.type);
      fdata.append("is_hero_offer", data.is_banner);
      fdata.append("heading_priority", data.heading_priority);
      fdata.append(
        "expiry_date",
        data.expiry_date && data.expiry_date + " 00:00:00",
      );
      fdata.append("latitude", data.latitude);
      fdata.append("longitude", data.longitude);

      if (data.is_banner === true) {
        if (data.banner_image) fdata.append("image", data.banner_image);
      } else {
        if (data.image) fdata.append("image", data.image);
        if (data.second_image) fdata.append("second_image", data.second_image);
      }

      let result = POST_API(fdata, "", path);
      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    }
  }
  if (keyword == "delete") {
    let result = DELETE_API("", params, path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageBranchOffers = async (e, data, keyword, params) => {
  let path = itemsOfferUrl;

  if (keyword == "get") {
    // let path ="/items/offer/";
    let result = GET_API("", params, path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "delete") {
    // let path ="/items/offer/";
    let result = DELETE_API("", params, path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const handleLogin = async (email, password) => {
  // e.preventDefault()
  let result = POST_API(
    {
      username: email,
      password: password,
    },
    {},
    "/user/login/",
  );

  return await result.then(function (result) {
    let value = -1;
    if (result) {
      if (result.data.Status === true) {
        if (result.data.is_deliveryboy === false) {
          let token = result.data;
          // setDataOnLocalstorage(token)
          setDataOnCookie(token);
          value = token;
        }
      }
    } else {
      value = 0;
    }

    return value;
  });

  return result;
};

export const getAllBranches = (paramData) => {
  let params = paramData;
  let path = branchDetailsUrl;
  let result = isDropdownQuery(params)
    ? fetchWithRestaurantDropdownCache(params, () => GET_API("", params, path))
    : GET_API("", params, path);
  return result.then((result) => {
    if (result) {
      return result;
    } else {
      return 0;
    }
  });
};

export const DELETE_NOTIFICATION_TOKEN = () => {
  let path = notificationsAdminTokenUrl;
  let params =
    "token_type=all_profile&token=" +
    localStorage.getItem("foodoor_notification_token");
  let result = DELETE_API("", params, path);
  return result.then((result) => {
    if (result) {
      return result;
    } else {
      return 0;
    }
  });
};

export const SET_NOTIFICATION_TOKEN = () => {
  let path = notificationsAdminTokenUrl;
  var fdata = new FormData();
  fdata.append("token", localStorage.getItem("foodoor_notification_token"));
  // fdata.append('token_type', 'web_token');
  let result = POST_API(fdata, "", path);

  return result.then((result) => {
    if (result) {
      return result;
    } else {
      return 0;
    }
  });
};

export const formValidation = (
  disc_perc,
  flat_disc,
  min_amount,
  expiry_date,
  from_date,
  code,
  recurrence,
  uplimit,
) => {
  if (!disc_perc && !flat_disc) {
    showMessage("required discount", "danger", "Error!", "top", "top-right", 0);
    return 0;
  } else {
    if (disc_perc) {
      if ((disc_perc <= 0) | (disc_perc > 99)) {
        showMessage(
          "Invalid discount amount, please provide value between 0 to 99",
          "danger",
          "Error!",
          "top",
          "top-right",
          0,
        );

        return 0;
      } else {
      }
    } else {
    }

    if (flat_disc) {
      if (parseFloat(flat_disc) > parseFloat(min_amount)) {
        showMessage(
          "flat amount cannot be greater than minimum order value",
          "danger",
          "Error!",
          "top",
          "top-right",
          0,
        );

        return 0;
      }
    }
  }

  if (expiry_date === "") {
    showMessage(
      "Expiry date is required",
      "danger",
      "Error!",
      "top",
      "top-right",
      0,
    );
    return 0;
  }

  if (disc_perc !== 0 && uplimit == "") {
    showMessage(
      "Uplimit is required",
      "danger",
      "Error!",
      "top",
      "top-right",
      0,
    );
    return 0;
  }

  if (!min_amount) {
    showMessage(
      "Minimum amout is required",
      "danger",
      "Error!",
      "top",
      "top-right",
      0,
    );
    return 0;
  }

  if (from_date) {
    let from = new Date(from_date);
    if (from.toLocaleDateString() < new Date().toLocaleDateString()) {
      showMessage(
        "Start date should not be before todays date",
        "danger",
        "Error!",
        "top",
        "top-right",
        0,
      );

      return 0;
    }
  }

  if (expiry_date) {
    let expiry = new Date(expiry_date);
    let from = new Date(from_date);

    if (expiry < from) {
      showMessage(
        "Expiry date should be on or after starting date",
        "danger",
        "Error!",
        "top",
        "top-right",
        0,
      );

      return 0;
    }
    if (expiry < new Date()) {
      showMessage(
        "Expiry date should not be before todays date",
        "danger",
        "Error!",
        "top",
        "top-right",
        0,
      );

      return 0;
    }
  }

  // return 0
  if (!code) {
    showMessage(
      "required Promocode",
      "danger",
      "Error!",
      "top",
      "top-right",
      0,
    );

    return 0;
  }

  if (code.length < 4) {
    showMessage(
      "Promocode must be 4 character",
      "danger",
      "Error!",
      "top",
      "top-right",
      0,
    );

    return 0;
  }

  if (code.trim() === "") {
    showMessage(
      "Invalid Promocode name",
      "danger",
      "Error!",
      "top",
      "top-right",
      0,
    );

    return 0;
  }
  if (!recurrence) {
    showMessage(
      "required recurrence",
      "danger",
      "Error!",
      "top",
      "top-right",
      0,
    );

    return 0;
  }

  return 1;
};

export const getRole = () => {};

export const random_rgba = () => {
  var o = Math.round,
    r = Math.random,
    s = 255;
  var opacity = 0.1;
  return (
    "rgba(" +
    o(r() * s) +
    "," +
    o(r() * s) +
    "," +
    o(r() * s) +
    "," +
    opacity.toFixed(1) +
    ")"
  );
};

function getDifferenceInDays(date1, date2) {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60 * 60 * 24);
}

function getDifferenceInHours(date1, date2) {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60 * 60);
}

function getDifferenceInMinutes(date1, date2) {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60);
}
function getDifferenceInSeconds(date1, date2) {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / 1000;
}

export const calculateTimeAndDate = (date1, date2) => {
  var dateDifference = getDifferenceInSeconds(date1, date2);

  if (dateDifference > 60) {
    dateDifference = getDifferenceInMinutes(date1, date2);

    if (dateDifference > 60) {
      dateDifference = getDifferenceInHours(date1, date2);

      if (dateDifference > 23.5) {
        dateDifference = getDifferenceInDays(date1, date2);

        return {
          time: Number(dateDifference.toFixed(0)) + " day",
          color: "purple",
        };
      } else {
        return {
          time: Number(dateDifference.toFixed(0)) + " hrs",
          color: "blue",
        };
      }
    } else {
      if (dateDifference < 5) {
        return {
          time: Number(dateDifference.toFixed(0)) + " min",
          color: "#07BD09",
        };
      } else if (dateDifference > 5 && dateDifference < 15) {
        return {
          time: Number(dateDifference.toFixed(0)) + " min",
          color: "orange",
        };
      } else if (dateDifference > 15)
        return {
          time: Number(dateDifference.toFixed(0)) + " min",
          color: "red",
        };
    }
  } else {
    return {
      time: Number(dateDifference.toFixed(0)) + " sec",
      color: "#07BD09",
    };
  }
};
export const substractTime = (date) => {
  date = new Date(date);
  date.setHours(date.getHours() - 5);
  date.setMinutes(date.getMinutes() - 30);
  return date;
};
export const formatAMPM = (date) => {
  let time = "";
  var dateUTC = date;
  var dateUTC = dateUTC.getTime();
  var dateIST = new Date(dateUTC);

  dateIST.setHours(dateIST.getHours());
  dateIST.setMinutes(dateIST.getMinutes());

  let date_time = dateIST.toString().slice(16, 24);

  time = date_time
    .toString()
    .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }

  return time;
};

export const formatTime = (time) => {
  var ts = time;
  var H = +ts.substr(0, 2);
  var h = H % 12 || 12;
  h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
  var ampm = H < 12 ? " AM" : " PM";
  ts = h + ts.substr(2, 3) + ampm;
  return ts;
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];
  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};

export const DIFFERENCE_OF_ARRAYS = (firstArray, secondArray) => {
  return firstArray.filter(
    (firstArrayItem) =>
      !secondArray.some(
        (secondArrayItem) => firstArrayItem.id === secondArrayItem.id,
      ),
  );
};

export const findCommonElementsInArray = (arr1, arr2) => {
  return arr1.some((item) => arr2.includes(item));
};
export const pop_by_name = (array, name) => {
  const index = array.indexOf(name);

  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
};
export const diffArray = (arr1, arr2) => {
  return arr1
    .concat(arr2)
    .filter((item) => !arr1.includes(item) || !arr2.includes(item));
};

export const FirstLetterOfWords = (scentence) => {
  return scentence
    .split(/\s/)
    .reduce((response, word) => (response += word.slice(0, 1)), "");
};

export const validURL = (str) => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // web protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name of the business
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address not considered v6
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path of url
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string of url
      "(\\#[-a-z\\d_]*)?$",
    "i",
  ); // url fragment locator
  return !!pattern.test(str);
};

export const trimFirstAndLastWhiteSpace = (string) => {
  let data = string;
  let cleanStr = data.trim();
  return cleanStr;
};

export const percentageValidation = (context_name, value) => {
  if (value >= 100) {
    showMessage(
      context_name + " should be less than 100",
      "danger",
      "Error!",
      "top",
      "top-right",
    );
    return;
  } else {
    return value;
  }
};

export const sleep = (milliseconds) => {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
};

export const excludeArrayFromArray = (ex_array, array) => {
  let ex_list = [
    "transaction_type",
    "mode_of_payment",
    "incentive",
    "amount_credited",
    "amount_debited",
  ];
  let modified_array = array.filter((item) => !ex_list.includes(item));

  return modified_array;
};

export const handleImageError = (e) => {
  if (!e.target.dataset.retried) {
    e.target.dataset.retried = "true";
    const currentSrc = e.target.src;
    if (currentSrc) {
      if (currentSrc.startsWith("http://")) {
        e.target.src = currentSrc.replace("http://", "https://");
      } else if (currentSrc.startsWith("https://")) {
        e.target.src = currentSrc.replace("https://", "http://");
      }
    }
  }
};
